module.exports = __webpack_public_path__ + "media/images/product-overlay-close-8117bf25.svg";